import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PublicPageLayout({
  eyebrow,
  title,
  intro,
  children,
  testid = "public-page",
}) {
  return (
    <div className="min-h-screen bg-slate-50" data-testid={testid}>
      <Navbar />
      <main className="pt-28 pb-24">
        <section className="max-w-4xl mx-auto px-6 lg:px-12">
          {eyebrow && (
            <p
              className="text-xs font-medium uppercase tracking-[0.18em] text-sky-700"
              data-testid={`${testid}-eyebrow`}
            >
              {eyebrow}
            </p>
          )}
          <h1
            className="mt-3 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-medium text-slate-900"
            data-testid={`${testid}-heading`}
          >
            {title}
          </h1>
          {intro && (
            <p
              className="mt-6 text-base sm:text-lg text-slate-600 max-w-2xl leading-relaxed"
              data-testid={`${testid}-intro`}
            >
              {intro}
            </p>
          )}
          <div className="mt-12 space-y-10">{children}</div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export function Section({ title, children, testid }) {
  return (
    <section data-testid={testid} className="space-y-3">
      <h2 className="text-xl sm:text-2xl font-medium text-slate-900 tracking-tight">
        {title}
      </h2>
      <div className="text-slate-600 leading-relaxed text-base space-y-3">
        {children}
      </div>
    </section>
  );
}
